/**
 * T041: useSignUp Hook
 * Mutation hook for sign-up flow
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { signUp, type SignUpInput } from '@/services/auth'
import { useAuthStore } from '@/stores/auth'
import { queryKeys } from '@/lib/query-keys'

export function useSignUp() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { setUser } = useAuthStore()

  return useMutation({
    mutationFn: (input: SignUpInput) => signUp(input),
    onSuccess: (data) => {
      setUser(data.user)
      queryClient.setQueryData(queryKeys.auth.me(), data)
      navigate({ to: '/prompts' })
    },
  })
}
